import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Trailing-slash rule per SEO Master §1: "/weight-management/" → "/weight-management".
// A real 301 must happen at the CDN / hosting layer (Nginx/Cloudflare/Netlify)
// so bots see it before hitting the SPA — this hook is a client-side belt-
// and-braces that also cleans up the browser URL. The <link rel="canonical">
// from the SEO component tells Googlebot the correct form regardless.
export default function TrailingSlashRedirect() {
  const { pathname, search, hash } = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (pathname === '/') return;
    if (pathname.endsWith('/')) {
      navigate(`${pathname.replace(/\/+$/, '')}${search}${hash}`, { replace: true });
    }
  }, [pathname, search, hash, navigate]);

  return null;
}
